import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CookieService} from "ngx-cookie-service";
import {safeParseJson} from "../utils/safe-json";
import {isAuthEntryRequest} from "../utils/auth-entry-requests";

@Injectable()
export class ApiRequestInterceptorService implements HttpInterceptor {

  constructor(
    private cookieService: CookieService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const userData = this.cookieService.get('iolrUserData');
    let token: string | null = null;

    if (userData) {
      const parsed = safeParseJson<{ token?: string }>(userData);
      if (parsed) {
        token = parsed.token ?? null;
      } else {
        // Malformed cookie — clear it so the user can re-login cleanly
        // instead of every request silently throwing on JSON.parse.
        this.cookieService.delete('iolrUserData', '/');
      }
    }

    // A request that establishes a session must not carry the old one. Sending a stale bearer
    // token to /auth/login made a wrong-password 401 indistinguishable from an expired-session
    // 401 on the response side (#34).
    if (isAuthEntryRequest(req)) {
      token = null;
    }

    if (token) {
      req = req.clone({
        setHeaders: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      });
    } else {
      req = req.clone({
        setHeaders: {
          'Accept': 'application/json, text/plain',
          'Content-Type': 'application/json',
        },
      });
    }
    return next.handle(req);
  }

}
